export const USER_ATTR_OPT = 'productAttribute';
export const PADB_OPT = 'padb';
export const CUSTOM_OPT = 'custom';
export const CUSTOM_LABEL_OPT = 'label';
export const CUSTOM_VALUE_OPT = 'value';

export const attrOptions: any = [{
  option: PADB_OPT,
  title: 'PAdb',
}, {
  option: CUSTOM_OPT,
  title: 'Custom',
}];

export const customAttrOptions: any = [{
  option: CUSTOM_LABEL_OPT,
  title: 'Search by label',
}, {
  option: CUSTOM_VALUE_OPT,
  title: 'Search by value',
}];
